import { render, staticRenderFns } from "./CryptoAddress.vue?vue&type=template&id=1b5e405f&scoped=true"
import script from "./CryptoAddress.vue?vue&type=script&lang=js"
export * from "./CryptoAddress.vue?vue&type=script&lang=js"
import style0 from "./CryptoAddress.vue?vue&type=style&index=0&id=1b5e405f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5e405f",
  null
  
)

export default component.exports